import script from "./ProfileInterview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileInterview.vue?vue&type=script&setup=true&lang=js"

import "./ProfileInterview.vue?vue&type=style&index=0&id=78888dfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78888dfe"]])

export default __exports__